import classNames from "classnames";
import styles from './Message.module.scss'

type Props = {
  children: React.ReactNode
  type?: 'error' | 'success' | 'warning'
  className?: string
}

const Message = (props: Props) => {
  return (
    <div className={classNames(styles.message, props.className, {
      [styles.error]: props.type === 'error',
      [styles.success]: props.type === 'success',
      [styles.warning]: props.type === 'warning',
    })}>
      {props.children}
    </div>
  )
}

export default Message;